const StatusDocumentEnum = {
  CANCELED: {               value:  'cancelado',              code: 16 },   // Cancelado
  ANALYZING: {              value:  'em análise',             code: 17 },   // Analise
  AWAITING_SIGNATURE: {     value:  'aguardando assinatura',  code: 18 },   // Aguardando Assinatura
  SIGNED: {                 value:  'aguardando emissão',     code: 19 },   // Assinado Cades
  SIGNATURE_REJECTED: {     value:  'assinatura recusada',    code: 20 },   // Assinatura Recusada
  GENERATED_CERTIFICATE: {  value:  'baixar certificado',     code: 21 },   // Certificado Emitido Pades
  COMPLETE: {               value:  'concluído',              code: 22 },   // Concluído
};

const getStatusByCode = (code) => {
  code = parseInt(code, 10)
  let status = ''
  if(code) {
    switch (code) {
      case StatusDocumentEnum.CANCELED.code:
        status = StatusDocumentEnum.CANCELED.value
        break;
      case StatusDocumentEnum.ANALYZING.code:
        status = StatusDocumentEnum.ANALYZING.value
        break;
      case StatusDocumentEnum.AWAITING_SIGNATURE.code:
        status = StatusDocumentEnum.AWAITING_SIGNATURE.value
        break;
      case StatusDocumentEnum.SIGNED.code:
        status = StatusDocumentEnum.SIGNED.value
        break;
      case StatusDocumentEnum.SIGNATURE_REJECTED.code:
        status = StatusDocumentEnum.SIGNATURE_REJECTED.value
        break;
      case StatusDocumentEnum.GENERATED_CERTIFICATE.code:
        status = StatusDocumentEnum.GENERATED_CERTIFICATE.value
        break;
      case StatusDocumentEnum.COMPLETE.code:
        status = StatusDocumentEnum.COMPLETE.value
        break;

      default:
        break;
    }
  }

  return status
}

module.exports = {StatusDocumentEnum, getStatusByCode}
